import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { onBrandSearch } from "../../controller/BrandController";
import 'react-toastify/dist/ReactToastify.css';
import toast, { Toaster } from 'react-hot-toast';
import AuthUtility from "../../util/AuthUtility";
import { Col, Button, Row, Container, Card, Form, InputGroup, Table, Pagination } from 'react-bootstrap';
import { Page } from "../../dto/page/Page";
import SearchIcon from '@mui/icons-material/Search';
import InfoIcon from '@mui/icons-material/Info';
import { BrandSearch } from "../../dto/brand/BrandSearch";
import { BrandListEntity } from "../../dto/brand/BrandListEntity";
import { BrandEntity } from "../../dto/brand/BrandEntity";
import { PolicySearch } from "../../dto/policy/PolicySearch";
import { onPolicySearch } from "../../controller/PolicyController";
import { PolicyEntity } from "../../dto/policy/PolicyEntity";
import { PolicyListEntity } from "../../dto/policy/PolicyListEntity";

const PolicyList = () => {
    const navigate = useNavigate();
    useEffect(() => {
        if (!AuthUtility.isUserLoggedIn()) {
            navigate("/login");
            window.location.reload();
        }
    }, [])

    const [render, setRender] = useState(0);
    const [policySearch, setPolicySearch] = useState<PolicySearch>({
        offset: -1,
        limit: 10
    });
    const [policies, setPolicies] = useState<PolicyListEntity>({
        page: undefined,
        data: []
    });

    const policySearchSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        if (policySearch.offset === 0) {
            const tmp = render + 1;
            setRender(tmp);
        } else {
            setPolicySearch({
                ...policySearch,
                offset: 0
            })
        }
    }

    const policySearchFunction = async (offset: number) => {
        if (offset === -1) {
            const response = await onPolicySearch(policySearch);
            if (response.status !== 0) {
                // error
            } else {
                const pageable = response.data;
                const page: Page = {
                    limit: policySearch.limit,
                    totalElements: pageable.totalElements,
                    totalPages: pageable.totalPages,
                    offset: policySearch.offset
                }
                const beans: Array<PolicyEntity> = pageable.beans;
                setPolicies({
                    page: page,
                    data: beans
                })
            }
        } else {
            const tmpSearch: PolicySearch = {
                offset: 0,
                limit: policySearch.limit
            }
            const response = await onPolicySearch(tmpSearch);
            if (response.status !== 0) {
                // error
            } else {
                const pageable = response.data;
                const page: Page = {
                    limit: policySearch.limit,
                    totalElements: pageable.totalElements,
                    totalPages: pageable.totalPages,
                    offset: policySearch.offset
                }
                const beans: Array<BrandEntity> = pageable.beans;
                setPolicies({
                    page: page,
                    data: beans
                })
            }
        }
    }

    const paginate = async (event: React.MouseEvent) => {
        event.preventDefault();
        const element = event.target as HTMLLinkElement;
        setPolicySearch({
            ...policySearch,
            offset: parseInt(element.innerText) - 1
        });
    }

    useEffect(() => {
        if (policySearch.offset !== -1) {
            policySearchFunction(0);
        }
    }, [render]);

    useEffect(() => {
        if (policySearch.offset !== -1) {
            policySearchFunction(-1);
        }
    }, [policySearch.offset]);

    return (
        <Container fluid>
            <div><Toaster position="top-right" reverseOrder={false}/></div>
            <h3><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Үйлчилгээний нөхцөл</h3>
            <Row className="d-flex justify-content-center align-items-center mb-3">
                <Col md={12} lg={12} xs={12}>
                    <Card>
                        <Card.Header>
                            <Form onSubmit={policySearchSubmit}>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group className="mb-3" controlId="offSet">
                                            <Form.Label>Багцлах</Form.Label>
                                            <InputGroup className="mb-3">
                                                <Form.Select size="sm"
                                                    onChange={(event) => setPolicySearch({
                                                        ...policySearch,
                                                        limit: parseInt(event.target.value)
                                                    })}>
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="1000000">Бүгд</option>
                                                </Form.Select>
                                                <Button variant="primary" size="sm" type="submit">
                                                    <SearchIcon fontSize="small"/>
                                                </Button>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Header>
                        <Card.Body>
                            <Table hover>
                                <thead>
                                    <tr>
                                        <th>Type</th>
                                        <th>Active</th>
                                        <th>Text</th>
                                        <th><InfoIcon /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        policies.data.map((data, idx) => {
                                            return (
                                                <tr key={idx}>
                                                    <td>{data.type}</td>
                                                    <td>{data.activeFlag == true ? "Active" : "Inactive"}</td>
                                                    <td>{data.text}</td>
                                                    <th><a href={`/policy/${data.id}`}><InfoIcon /></a></th>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </Col>  
            </Row>
            <Row>
                <Col md={12} lg={12} xs={12}>
                    {
                        policies.page &&
                        policies.page.totalPages > 1 && (
                        <Pagination>
                            {
                                policies.page.offset + 1 === 1 ? (
                                    <>
                                        <Pagination.Item active onClick={(event) => paginate(event)}>{policies.page.offset + 1}</Pagination.Item>
                                        <Pagination.Item onClick={(event) => paginate(event)}>{policies.page.offset + 2}</Pagination.Item>
                                    {
                                        (policies.page.offset + 2 < policies.page.totalPages) && ( 
                                        <>
                                            <Pagination.Ellipsis />
                                            <Pagination.Item onClick={(event) => paginate(event)}>{policies.page.totalPages}</Pagination.Item>
                                        </>
                                        )
                                    }
                                    </>
                                ) : (
                                    <>
                                        {
                                            policies.page.offset + 1 > 1 && (
                                                <>
                                                    {
                                                        policies.page.offset === 1 ? (
                                                            <Pagination.Item onClick={(event) => paginate(event)}>1</Pagination.Item>
                                                        ) : (
                                                            <>
                                                                <Pagination.Item onClick={(event) => paginate(event)}>1</Pagination.Item>
                                                                <Pagination.Ellipsis />
                                                                <Pagination.Item onClick={(event) => paginate(event)}>{policies.page.offset}</Pagination.Item>
                                                            </>
                                                        )
                                                    }
                                                    <Pagination.Item active onClick={(event) => paginate(event)}>{policies.page.offset + 1}</Pagination.Item>
                                                    {
                                                        policies.page.offset + 1 < policies.page.totalPages && (
                                                            <>
                                                                {
                                                                    policies.page.offset + 2 === policies.page.totalPages ? (
                                                                        <Pagination.Item onClick={(event) => paginate(event)}>{policies.page.totalPages}</Pagination.Item>
                                                                    ) : (
                                                                        <>
                                                                            <Pagination.Item onClick={(event) => paginate(event)}>{policies.page.offset + 2}</Pagination.Item>
                                                                            <Pagination.Ellipsis />
                                                                            <Pagination.Item onClick={(event) => paginate(event)}>{policies.page.totalPages}</Pagination.Item>
                                                                        </>
                                                                    )
                                                                }
                                                            </>
                                                        )
                                                    }
                                                </>
                                            )
                                        }
                                    </>
                                )
                            }
                        </Pagination>
                        )
                    }
                </Col>
            </Row>
        </Container>
    )
}

export default PolicyList;